// lib/form-config.js
export const formConfig = {
  // User type options
  userTypes: [
    { 
      value: "individual", 
      label: "Individual", 
      description: "For individuals interested in humanitarian work",
      icon: "👤"
    },
    { 
      value: "expert", 
      label: "Expert/Consultant", 
      description: "For professionals offering expertise",
      icon: "🎓"
    },
    { 
      value: "ngo", 
      label: "NGO/Local Organization", 
      description: "For non-governmental organizations",
      icon: "🏢"
    },
    { 
      value: "employee", 
      label: "International Organization", 
      description: "For international organizations & UN agencies",
      icon: "🌍"
    }
  ],

  // Countries for dropdowns
  countries: [
    { value: "ye", label: "Yemen", code: "+967" },
    { value: "sa", label: "Saudi Arabia", code: "+966" },
    { value: "ae", label: "United Arab Emirates", code: "+971" },
    { value: "eg", label: "Egypt", code: "+20" },
    { value: "us", label: "United States", code: "+1" },
    { value: "gb", label: "United Kingdom", code: "+44" },
    { value: "fr", label: "France", code: "+33" },
    { value: "de", label: "Germany", code: "+49" },
    { value: "tr", label: "Turkey", code: "+90" },
    { value: "jo", label: "Jordan", code: "+962" },
  ],

  // Yemeni cities
  yemeniCities: [
    "Sana'a",
    "Aden",
    "Taiz",
    "Al Hudaydah",
    "Ibb",
    "Dhamar",
    "Al Mukalla",
    "Say'un",
    "Zinjibar",
    "Al Ghaydah",
    "Ash Shihr",
    "Bajil",
    "Al Bayda",
    "Amran",
    "Al Mahwit",
    "Hajjah",
    "Sa'dah",
    "Marib",
    "Lahij",
    "Ataq",
  ],

  // Organization types
  organizationTypes: [
    { value: "ngo", label: "Non-Governmental Organization (NGO)" },
    { value: "cbo", label: "Community-Based Organization (CBO)" },
    { value: "faith", label: "Faith-Based Organization" },
    { value: "academic", label: "Academic/Research Institution" },
    { value: "government", label: "Government Agency" },
    { value: "private", label: "Private Sector Company" },
    { value: "media", label: "Media Organization" },
    { value: "network", label: "Network/Coalition" },
    { value: "un", label: "United Nations Agency" },
    { value: "ingo", label: "International NGO" },
    { value: "donor", label: "Donor Agency" },
    { value: "other", label: "Other" },
  ],

  // Staff sizes
  staffSizes: [
    { value: "1-10", label: "1-10 employees" },
    { value: "11-50", label: "11-50 employees" },
    { value: "51-200", label: "51-200 employees" },
    { value: "201-500", label: "201-500 employees" },
    { value: "501-1000", label: "501-1,000 employees" },
    { value: "1000+", label: "1,000+ employees" },
  ],

  // Communication preferences
  communicationPrefs: [
    { value: "both", label: "Newsletter & Event Updates" },
    { value: "newsletter", label: "Newsletter Only" },
    { value: "events", label: "Event Updates Only" },
    { value: "none", label: "No Communications" },
  ],

  // Months for founding date
  months: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ],

  // Years for founding date (from 1900 to current year)
  getYears: () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = 1900; year <= currentYear; year++) {
      years.push({ value: year.toString(), label: year.toString() });
    }
    return years.reverse();
  },

  // File upload configuration
  fileUpload: {
    cv: {
      accept: ".pdf,.doc,.docx",
      maxSize: 5 * 1024 * 1024, // 5MB
      types: ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
    },
    organization: {
      accept: ".pdf",
      maxSize: 10 * 1024 * 1024, // 10MB
      types: ["application/pdf"]
    }
  }
};

// Helper function to get country flag
export const getCountryFlag = (countryCode) => {
  const flags = {
    'ye': '🇾🇪',
    'sa': '🇸🇦',
    'ae': '🇦🇪',
    'eg': '🇪🇬',
    'us': '🇺🇸',
    'gb': '🇬🇧',
    'fr': '🇫🇷',
    'de': '🇩🇪',
    'tr': '🇹🇷',
    'jo': '🇯🇴',
  };
  return flags[countryCode] || '🇺🇳';
};